export default __webpack_public_path__ + "static/radovi7-6c41b9c3fb909e958cf022cfe01ecbcc.png";